import request from '@/utils/request'

/**
 * 按 feeId 批量查询费用金额汇总（已收/已开票/减免）
 * 用于欠费列表展示资金流向
 * @param {Object} data - { communityId, feeIds(逗号分隔) }
 * @returns Promise<{feeId, receivedAmount, deductionAmount, invoicedAmount}[]>
 */
export function listFeeAmountSummary(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/fee.listFeeAmountSummary',
      method: 'post',
      data
    }).then(response => {
      resolve(response.data || response)
    }).catch(error => {
      reject(error)
    })
  })
}
